import React from 'react';
import CoverImageSecond from './CoverImageSecond';
import Service2 from './Service2';
import Service2second from './Service2second';
import ReservationForm from './ReservationForm';


import Footer from './Footer';


const Wedding = () => {
    return (
        <div>
            <CoverImageSecond />
            <Service2 />
            {/*<Service2second />*/}
            <ReservationForm />

            <Footer/>

        </div>
    );
};

export default Wedding;